export default __webpack_public_path__ + "static/media/Add-2.19d27667.svg";